import CircularProgressBar from './CircularProgressBar';

export default CircularProgressBar;
